export default "__VITE_ASSET__D1vuhk4___"